import clsx from 'clsx';
import React, { useState } from 'react';
import styles from './Timeline.module.scss';
export const Timeline = ({ items, selectedByDefault = '' }) => {
    const [selected, setSelected] = useState(selectedByDefault);
    return (<div className={styles.timelineContainer}>
      {items.map((item) => (<div className={clsx(styles.timelineItem, selected === item.id && styles.selected)} key={item.id}>
          <div className={styles.timelineItemHeader} role='presentation' onClick={() => setSelected(item.id)}>
            <div className={clsx(styles.timelineIcon, selected === item.id ? styles.selected : styles[item.icon])}>
              {item.icon === 'checked' && (<img src='https://www.haven.com/assets/owners/shared/check.svg' alt='check' role='presentation'/>)}
            </div>
            <p className={styles[item.icon]}>{item.title}</p>
            {item.headerExtraContent}
          </div>
          {selected === item.id && (<div className={clsx(styles.timelineContent)}>{item.content}</div>)}
        </div>))}
    </div>);
};
